var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_shared-key.js
// module id = 153
// module chunks = 168707334958949